import { Linking } from 'react-native';
import Config from 'react-native-config';

export const supportConfig = {
  phoneNumber: Config.SUPPORT_PHONE_NUMBER || '+390238592676',

  call: () => Linking.openURL(`tel:${supportConfig.phoneNumber}`),
} as const;
